export type LayoutRenderer = 'grid' | 'carousel' | 'alternating' | 'accordion';

export interface LayoutVariantEntry {
  key: string;
  label: string;
  renderer: LayoutRenderer;
  defaultProps: Record<string, unknown>;
}

export type CollectionRenderer = LayoutRenderer;
export type DataWidgetRenderer = LayoutRenderer;

const SHARED_VARIANT_ENTRIES: Record<LayoutRenderer, LayoutVariantEntry> = {
  grid: {
    key: 'grid',
    label: 'Grid',
    renderer: 'grid',
    defaultProps: {
      columns: { mobile: 1, tablet: 2, desktop: 3 },
      gap: 'md',
    },
  },
  alternating: {
    key: 'alternating',
    label: 'Alternating',
    renderer: 'alternating',
    defaultProps: {
      gap: 'sm',
    },
  },
  carousel: {
    key: 'carousel',
    label: 'Carousel',
    renderer: 'carousel',
    defaultProps: {
      itemsPerView: { mobile: 1, tablet: 2, desktop: 3 },
      gap: 'md',
      arrows: true,
      imagePosition: 'top',
      verticalHeight: 'md',
      navPosition: 'sides',
      navButtonStyle: 'outline',
    },
  },
  accordion: {
    key: 'accordion',
    label: 'Accordion',
    renderer: 'accordion',
    defaultProps: {
      columns: { mobile: 1, tablet: 1, desktop: 1 },
      gap: 'sm',
    },
  },
};

const COLLECTION_VARIANT_KEYS = ['grid', 'alternating', 'carousel', 'accordion'] as const;
const DATA_WIDGET_VARIANT_KEYS = COLLECTION_VARIANT_KEYS;

type VariantKey = keyof typeof SHARED_VARIANT_ENTRIES;

function getEntries(keys: readonly VariantKey[]): LayoutVariantEntry[] {
  return keys.map((key) => SHARED_VARIANT_ENTRIES[key]);
}

const COLLECTION_VARIANTS = getEntries(COLLECTION_VARIANT_KEYS);
const DATA_WIDGET_VARIANTS = getEntries(DATA_WIDGET_VARIANT_KEYS);

export function getCollectionVariants(): LayoutVariantEntry[] {
  return COLLECTION_VARIANTS;
}

export function getDataWidgetVariants(): LayoutVariantEntry[] {
  return DATA_WIDGET_VARIANTS;
}

export function getVariantEntry(variantKey: string): LayoutVariantEntry | null {
  return SHARED_VARIANT_ENTRIES[variantKey as VariantKey] ?? null;
}
